import React, { ReactNode } from 'react';

type FormFieldLabelParam = {
    title?: string;
    width?: string;
};
export type FormFieldParams = {
    cssName?: string;
    label?: FormFieldLabelParam;
    children: ReactNode;
    flexDirection?: 'row' | 'column';
};

const FormField = ({ cssName, flexDirection, label, children }: FormFieldParams): JSX.Element => {
    const rowCss = 'form-field ' + (cssName ? cssName : '');
    return (
        <div
            className={rowCss}
            style={{ flexDirection: flexDirection || 'row' }}
        >
            {label ? <label className={label.width}>{label.title}</label> : null}
            {children}
        </div>
    );
};

export default FormField;
